import { render } from "./user.vue?vue&type=template&id=4aefd206&bindings={\"uploadFile\":\"options\",\"uploadClick\":\"options\"}"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script